import dagre from "dagre";
import { ReactFlowInstance } from "reactflow";

import { Edge, Node, XYPosition } from "Types/Journey";

export function recenterCanvas(
    anchorPoint: XYPosition,
    flowElement: HTMLElement | null,
    reactFlowInstance: ReactFlowInstance
): void {
    const flowContainer = flowElement || document.querySelector(".react-flow");
    const height = flowContainer?.getBoundingClientRect().height || 0;

    const xOffset = anchorPoint.x + 79; // x coord is fine without fucking around
    const yOffset = anchorPoint.y - 50 + height / 2; // set center to trigger node, at top of canvas, with 50 padding
    const zoom = reactFlowInstance.getZoom();
    reactFlowInstance.setCenter(xOffset, yOffset, { zoom });
}

// copied from src/Pages/journeys/JourneyEditPage/Components/JourneyBuilder/shared/hooks/useAutoOrganize.ts
// and removed dispatch(resetCanvasAnchorPoint); and dispatch(updateCanvasAnchorPoint({ x: dagreX, y: dagreY }));
export function reorganizeNodes(
    nodes: Array<Node>,
    edges: Array<Edge>
): {
    nodes: Array<Node>;
    anchorPoint: XYPosition;
} {
    let anchorPoint: XYPosition = { x: 0, y: 0 };

    const dagreGraph = new dagre.graphlib.Graph();
    dagreGraph.setDefaultEdgeLabel(() => ({}));

    // for height and width offset, in practice the width should be larger than node size,
    // so theres some spacing between nodes horizontally. Hieght should actually be smaller, otherwise
    // the veritcal gap is huge
    const widthOffset = 200; // ~ double max possible node width (85px) + A bit of padding
    const heightOffset = 75; // ~ half of the max possibly node height (135px)

    // direction top to bottom (other option is left to right)
    dagreGraph.setGraph({ rankdir: "TB" });

    // iterate through elements to add edge or node as approriate to dagre graph. The elements in
    // this iteration will ONLY be the edges and nodes which are connected to trigger node.
    nodes.forEach((el) => {
        dagreGraph.setNode(el.id, { width: widthOffset, height: heightOffset });
    });
    edges.forEach((el) => {
        dagreGraph.setEdge(el.source, el.target);
    });

    dagre.layout(dagreGraph);
    const updatedNodes: Array<Node | undefined> = nodes.map((el) => {
        const nodeWithPosition = dagreGraph.node(el.id);
        // We are shifting the dagre node position (anchor=center center) to the top left
        // so it matches the React Flow node anchor point (top left).
        if (el.type === "trigger") {
            const { x, y, width, height } = nodeWithPosition;
            const dagreX = x - width / 2;
            const dagreY = y - height / 2;
            anchorPoint = { x: dagreX, y: dagreY };
        }

        return {
            ...el,
            position: {
                x: nodeWithPosition.x - widthOffset / 2,
                y: nodeWithPosition.y - heightOffset / 2,
            },
        } as Node;
    });
    return { nodes: updatedNodes.filter((n) => !!n) as Array<Node>, anchorPoint };
}
